import { auth } from "./firebase";

// https://firebase.google.com/docs/auth/web/manage-users

const addUser = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password);

const sendEmail = () => {
  const user = auth.currentUser;
  return user.sendEmailVerification();
};

const signOut = () => auth.signOut();

const signInUser = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

const AuthService = {
  addUser,
  signInUser,
  signOut,
  sendEmail,
};

export default AuthService;
